import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

const useSharedStyles = () => {
    const { gray700, gray900 } = colors;

    const sharedStyles: CSSObject = {
        "& > div:first-of-type": {
            display: "flex",
            alignItems: "center",
            color: gray900,
            fontWeight: "600",
            lineHeight: "20px",

            "& > span": {
                marginLeft: "8px"
            }
        },

        "& > div:last-of-type": {
            display: "inline-grid",
            gridTemplateColumns: "auto auto",
            gridColumnGap: "24px",
            gridRowGap: "16px",
            wordBreak: "break-word",
            fontWeight: "500",
            marginTop: "16px",

            "& > span": {
                display: "flex",
                columnGap: "8px",
                lineHeight: "20px",

                "& > form": {
                    display: "inherit",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: "8px"
                },

                "& > button, span + button": {
                    alignSelf: "flex-start"
                }
            },

            "& > span:nth-of-type(odd)": {
                color: gray700,
                padding: "2px 0"
            },

            "& > span:nth-of-type(even)": {
                color: gray900,
                alignItems: "center"
            },

            "@media (max-width: 599px)": {
                display: "block",

                "& > span:nth-of-type(2n + 1)": {
                    marginTop: "16px"
                }
            },

            "@media (min-width: 840px) and (max-width: 979px)": {
                display: "block",

                "& > span:nth-of-type(2n + 1)": {
                    marginTop: "16px"
                }
            }
        }
    };

    return { sharedStyles };
};

export { useSharedStyles };
